import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import {
  FORMATTED_POWER_VALUE_FALLBACK,
  formatPowerValue,
  PowerBaseUnit,
} from '../utils/format-power-value.function';

export interface IPowerPipeValue {
  value: string;
  unit: string | null;
}

@Pipe({
  name: 'power',
  standalone: true,
})
export class PowerPipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  public transform(
    value: unknown,
    baseUnit: PowerBaseUnit,
    fallback = FORMATTED_POWER_VALUE_FALLBACK,
  ): IPowerPipeValue {
    return formatPowerValue(value, {
      baseUnit,
      locale: this.locale,
      fallback,
    });
  }
}
